import { postMypageUserMail } from "../../api/v1/mypage/user/mail/post"
import { MypageUserMailPostInputModel } from "../../api/v1/mypage/user/mail/PostInputModel"

/** 通知用メールアドレス登録 */
export const registerNotificationMail = (
  mailAddress: string,
): Promise<void> => {
  return postMypageUserMail(new MypageUserMailPostInputModel(mailAddress))
}
